<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-top">
        <div class="footer-brand">
          <div class="footer-logo">
            <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#ff9600" stroke-width="2">
              <path d="M23 7l-7 5 7 5V7z" fill="#ff9600" fill-opacity="0.3"/>
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2" stroke="#ff9600" fill="#ff9600" fill-opacity="0.15"/>
            </svg>
            <span>灵眸云图</span>
          </div>
          <p class="footer-desc">精彩直播，尽在灵眸云图</p>
        </div>
        <div class="footer-links">
          <div class="link-group">
            <h4>关于我们</h4>
            <router-link to="/about">公司介绍</router-link>
            <router-link to="/about">联系我们</router-link>
            <router-link :to="{ path: '/agreement', query: { type: 'user' } }">用户协议</router-link>
            <router-link :to="{ path: '/agreement', query: { type: 'privacy' } }">隐私政策</router-link>
          </div>
          <div class="link-group">
            <h4>帮助中心</h4>
            <router-link :to="{ path: '/help', query: { tab: 'faq' } }">常见问题</router-link>
            <router-link :to="{ path: '/help', query: { tab: 'live' } }">直播指南</router-link>
            <!-- 青少年模式下隐藏礼物/充值说明：内容含套餐价目与支付引导，
                 等同向未成年人推广消费 -->
            <router-link v-if="!minorMode" :to="{ path: '/help', query: { tab: 'gift' } }">礼物说明</router-link>
            <router-link v-if="!minorMode" :to="{ path: '/help', query: { tab: 'recharge' } }">充值帮助</router-link>
          </div>
          <div class="link-group">
            <h4>联系我们</h4>
            <span class="contact-item">电话：13691135537</span>
            <span class="contact-item">邮箱：contact@lingmouyuntu.com</span>
            <span class="contact-item">地址：北京市丰台区</span>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="copyright">
          <p>© 2025 北京灵眸云图科技有限公司. All rights reserved.</p>
          <div class="company-info">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">京ICP备2025135379号-1</a>
            <span class="divider">|</span>
            <span>北京灵眸云图科技有限公司</span>
          </div>
        </div>
      </div>
    </div>
    <transition name="tip-fade">
      <div class="footer-tip" v-if="tipVisible">{{ tipMessage }}</div>
    </transition>
  </footer>
</template>

<script>
import { getRealnameStatus } from '../api/realname';

export default {
  name: 'PageFooter',
  data() {
    return {
      tipVisible: false,
      tipMessage: '',
      tipTimer: null,
      minorMode: false
    };
  },
  mounted() {
    this.fetchMinorMode();
    this.onMinorModeChanged = () => this.fetchMinorMode();
    window.addEventListener('minor-mode-changed', this.onMinorModeChanged);
  },
  beforeUnmount() {
    if (this.tipTimer) clearTimeout(this.tipTimer);
    if (this.onMinorModeChanged) {
      window.removeEventListener('minor-mode-changed', this.onMinorModeChanged);
    }
  },
  methods: {
    fetchMinorMode() {
      getRealnameStatus().then(res => {
        const d = res && (res.data || res);
        this.minorMode = !!(d && Number(d.minor_mode) === 1);
      }).catch(() => { /* 异常时保持显示，不影响正常用户 */ });
    },
    showTip(name) {
      this.tipVisible = true;
      this.tipMessage = `${name}功能即将上线，敬请期待`;
      if (this.tipTimer) clearTimeout(this.tipTimer);
      this.tipTimer = setTimeout(() => {
        this.tipVisible = false;
      }, 2000);
    }
  }
}
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%);
  color: #fff;
  padding: 48px 0 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.footer-content {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-top {
  display: flex;
  gap: 60px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-brand {
  flex-shrink: 0;
  width: 240px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
}

.footer-desc {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  margin: 0;
  line-height: 1.6;
}

.footer-links {
  flex: 1;
  display: flex;
  justify-content: space-around;
  gap: 40px;
}

.link-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.link-group h4 {
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 6px;
}

.link-group a,
.contact-item {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
  line-height: 1.6;
}

.link-group a:hover {
  color: #ff9600;
}

.contact-item {
  display: block;
  cursor: default;
}

.footer-bottom {
  padding: 20px 0;
  text-align: center;
}

.copyright p {
  margin: 0 0 8px;
  color: rgba(255, 255, 255, 0.35);
  font-size: 13px;
}

.company-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.35);
  font-size: 13px;
}

.company-info a {
  color: rgba(255, 255, 255, 0.35);
  text-decoration: none;
  transition: color 0.3s;
}

.company-info a:hover {
  color: #ff9600;
}

.divider {
  color: rgba(255, 255, 255, 0.15);
}

.footer-tip {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(30, 30, 46, 0.95);
  color: #fff;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 150, 0, 0.3);
  z-index: 9999;
  white-space: nowrap;
}

.tip-fade-enter-active,
.tip-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.tip-fade-enter-from,
.tip-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(10px);
}

@media (max-width: 768px) {
  .footer {
    padding: 32px 0 0;
  }
  .footer-top {
    flex-direction: column;
    gap: 32px;
  }
  .footer-brand {
    width: 100%;
    text-align: center;
  }
  .footer-logo {
    justify-content: center;
  }
  .footer-links {
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 24px;
  }
  .link-group {
    width: calc(50% - 12px);
  }
  .company-info {
    flex-direction: column;
    gap: 4px;
  }
  .divider {
    display: none;
  }
}
</style>